/* @flow */

type ProductImage = { width: number, src: string, src2x: string };

export type ProductType = {
  slug: string,
  name: string,
  shortName: string,
  crewSize: number,
  description: string,
  shortDescription: string,
  estimateDescription: string,
  images: {
    small: ProductImage,
    smallAlt: ProductImage,
    medium: ProductImage,
    large: ProductImage,
  },
};

const PRODUCTS: { [id: string]: ProductType } = {
  lite: {
    slug: 'lite',
    name: 'Lugg Pickup',
    shortName: 'Pickup',
    crewSize: 1,
    description:
      'Whether you’re moving your sofa or just some boxes, Lugg Pickup is perfect for moving just a few items.',
    shortDescription: 'Single item deliveries, small moves and smaller loads.',
    estimateDescription: 'Single item and small loads',
    images: {
      small: {
        width: 113,
        src: require('../assets/images/vehicles/small-lite.png'),
        src2x: require('../assets/images/vehicles/small-lite_2x.png'),
      },
      smallAlt: {
        width: 112,
        src: require('../assets/images/vehicles/small-lite-alt.png'),
        src2x: require('../assets/images/vehicles/small-lite-alt_2x.png'),
      },
      medium: {
        width: 165,
        src: require('../assets/images/vehicles/medium-lite.png'),
        src2x: require('../assets/images/vehicles/medium-lite_2x.png'),
      },
      large: {
        width: 206,
        src: require('../assets/images/vehicles/large-lite.png'),
        src2x: require('../assets/images/vehicles/large-lite_2x.png'),
      },
    },
  },
  pickup: {
    slug: 'pickup',
    name: 'Lugg Pickup',
    shortName: 'Pickup',
    crewSize: 2,
    description:
      'Whether you’re moving your sofa or just some boxes, Lugg Pickup is perfect for moving just a few items.',
    shortDescription: 'Single item deliveries, small moves and smaller loads.',
    estimateDescription: 'Single item and small loads',
    images: {
      small: {
        width: 113,
        src: require('../assets/images/vehicles/small-pickup.png'),
        src2x: require('../assets/images/vehicles/small-pickup_2x.png'),
      },
      smallAlt: {
        width: 112,
        src: require('../assets/images/vehicles/small-pickup-alt.png'),
        src2x: require('../assets/images/vehicles/small-pickup-alt_2x.png'),
      },
      medium: {
        width: 165,
        src: require('../assets/images/vehicles/medium-pickup.png'),
        src2x: require('../assets/images/vehicles/medium-pickup_2x.png'),
      },
      large: {
        width: 206,
        src: require('../assets/images/vehicles/large-pickup.png'),
        src2x: require('../assets/images/vehicles/large-pickup_2x.png'),
      },
    },
  },
  van: {
    slug: 'van',
    name: 'Lugg Van',
    shortName: 'Van',
    crewSize: 2,
    description:
      'Lugg Van is the ideal choice for a room full of stuff, such as your living room, dining room, or bedroom.',
    shortDescription: 'Multi-item deliveries and small moves.',
    estimateDescription: 'Room full of stuff',
    images: {
      small: {
        width: 106,
        src: require('../assets/images/vehicles/small-van.png'),
        src2x: require('../assets/images/vehicles/small-van_2x.png'),
      },
      smallAlt: {
        width: 104,
        src: require('../assets/images/vehicles/small-van-alt.png'),
        src2x: require('../assets/images/vehicles/small-van-alt_2x.png'),
      },
      medium: {
        width: 183,
        src: require('../assets/images/vehicles/medium-van.png'),
        src2x: require('../assets/images/vehicles/medium-van_2x.png'),
      },
      large: {
        width: 224,
        src: require('../assets/images/vehicles/large-van.png'),
        src2x: require('../assets/images/vehicles/large-van_2x.png'),
      },
    },
  },
  xl: {
    slug: 'xl',
    name: 'Lugg XL',
    shortName: 'XL',
    crewSize: 2,
    description:
      'Lugg XL is great for moving your apartment, a small office, and other oversized items.',
    shortDescription: 'Bulk furniture purchases, home staging and bigger moves.',
    estimateDescription: 'Studio and 1 bedroom apts',
    images: {
      small: {
        width: 129,
        src: require('../assets/images/vehicles/small-xl.png'),
        src2x: require('../assets/images/vehicles/small-xl_2x.png'),
      },
      smallAlt: {
        width: 128,
        src: require('../assets/images/vehicles/small-xl-alt.png'),
        src2x: require('../assets/images/vehicles/small-xl-alt_2x.png'),
      },
      medium: {
        width: 209,
        src: require('../assets/images/vehicles/medium-xl.png'),
        src2x: require('../assets/images/vehicles/medium-xl_2x.png'),
      },
      large: {
        width: 258,
        src: require('../assets/images/vehicles/large-xl.png'),
        src2x: require('../assets/images/vehicles/large-xl_2x.png'),
      },
    },
  },
};

export type ProductID = $Keys<typeof PRODUCTS>;
export default PRODUCTS;



// WEBPACK FOOTER //
// ./src/data/Products.js